import React from 'react'
import Modal from '../../Modal'
import Button from '../../Button'
import { formatedDate } from '../../../utils/formatDate'
import { removeUnderscore } from '../../../utils/removeUnderscore'

interface ActivityModalProps {
  open: boolean
  onClose: () => void
  activity: any | null
}

const ActivityModal: React.FC<ActivityModalProps> = ({ open, onClose, activity }) => {
  const renderField = (label: string, value: React.ReactNode) => (
    <div className="flex flex-col sm:flex-row sm:gap-4 items-start">
      <div className="min-w-[90px] sm:w-32 text-xs sm:text-sm font-medium text-gray-700 flex-shrink-0">{label}</div>
      <div className="text-xs sm:text-sm text-[#495057] font-medium break-words whitespace-pre-wrap">{value ?? 'N/A'}</div>
    </div>
  )

  return (
    <Modal
      open={open}
      close={onClose}
      title="Activity Details"
      widthClass="w-[calc(100%-32px)] sm:max-w-md md:max-w-[640px]"
      footer={
        <div className="flex justify-end">
          <Button text="Close" action={onClose} />
        </div>
      }
      showClose={false}
    >
      {activity ? (
        <div className="w-full space-y-3 sm:space-y-4">
          <div className="space-y-3 sm:space-y-4">
            <div className="space-y-2 sm:space-y-3">
              {renderField('Initiator:', activity.initiator?.fullName || activity.initiator?.name || 'N/A')}
              {renderField('Email:', activity.initiator?.email)}
              {renderField('Action:', activity.action ? activity.action.replace(/_/g, ' ') : 'N/A')}
              {renderField('Time:', formatedDate(activity.createdAt))}
              {renderField('Position:', activity.userType)}
            </div>
          </div>

          <div className="space-y-2 sm:space-y-3">
             {renderField('Description:', removeUnderscore(activity.description).toLowerCase())}
          </div>
        </div>
      ) : (
        <p className="text-xs sm:text-sm text-gray-500">No activity details available.</p>
      )}
    </Modal>
  )
}

export default ActivityModal